import { LabAssignedSampleLabel } from './SampleTrackingData';
import { BaseGet } from './BaseData';
import { appSettings } from '../AppSettings';

export interface Sample {
  sampleId: string;
  patientId: string;
  labId: string;
  foreignHash?: string;
  sampleBbid?: string;
  containerBbid?: string;
  volume?: number;
  collectionDate: Date;
  biobankId?: string;
  patientDeidentity?: string;
  createdAt: Date;
  updatedAt: Date;
  sampleTypeId: string;
  biobankDecision: string;
  sampleAvailabilityTypeId: string;
  sampleTags?: string[];
}

export interface SampleTag {
  name: string;
  description: string;
}

export async function GetSampleTags(accessToken?: string): Promise<ReadonlyArray<SampleTag>> {
  return await BaseGet(`${appSettings.api.endpoint}/api/v2/Tag/Sample`, accessToken);
}

export function getSampleIdentifier(sample: Sample, labAssignedSampleLabel?: LabAssignedSampleLabel) {
  return getTransitionSampleIdentifier(labAssignedSampleLabel as any, sample);
}

export const getTransitionSampleIdentifier = (labAssignedSampleLabel?: LabAssignedSampleLabel, sample?: Sample) =>
  labAssignedSampleLabel?.label ??
  sample?.sampleBbid ??
  sample?.containerBbid ??
  sample?.foreignHash ??
  sample?.sampleId ??
  '';

export function truncateGuid(guid: string) {
  return guid ? guid.substring(23) : '';
}

export function truncateNoDashGuid(guid: string) {
  return guid ? guid.substring(24) : '';
}
